import { Spinner } from "@/components/ui/spinner";

export function TriageStatusBadge() {
  return (
    <span className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap bg-blue-50 px-2 py-0.5 text-[10px] font-medium text-blue-700">
      <Spinner className="size-2.5" aria-hidden />
      Working
    </span>
  );
}
